import { doBootstrapOnboarding } from 'subapps/onboarding/actions'
import { doUpdateCompanyProfile } from '../../ducks/companyProfile'
import { V2_OWNER_PAGE } from '../../pages'

export function doSaveAndRedirect(fields) {
  return dispatch => {
    let currentSupportSolution = null
    if (fields.currentSupportSolutionText !== '') {
      currentSupportSolution = fields.currentSupportSolutionText
    } else {
      currentSupportSolution = fields.currentSupportSolutionSelect
    }
    const companyFields = {
      name: fields.name,
      numberOfEmployees: fields.numberOfEmployees,
      industry: fields.industry,
      currentSupportSolution,
    }
    return dispatch(doUpdateCompanyProfile(companyFields)).then(() => {
      // HACK (jscheel): We trigger a forced bootstrap here, as updating the
      // company name _may_ also update the account's subdomain. Not ideal but
      // the subdomain change is a side-effect of this action.
      dispatch(doBootstrapOnboarding())
      return dispatch({
        type: V2_OWNER_PAGE,
      })
    })
  }
}
